import { Component } from '@opten/compiler/metadata/component';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

import { getParentWithClass } from '@opten/dom/get-parent-with-class';
import { VehicleSliderSlideLoadContent } from './vehicle-slider-slide-load-content';

@Component({ className: 'js-vehicle-slider', observe: true })
export class VehicleSliderComponent {
	private instance: any;
	private allSliderElements: HTMLElement[];
	private sliderWrapper: HTMLElement;
	private counterHandleSliderSlidesFiltered: any;
	constructor(private element: HTMLElement) {
		if (hasClass(this.element, 'js-vehicle-slider--with-mixitup-filter')) {
			this.initSliderFilterable();
		} else {
			this.init();
		}

		window.addEventListener('resize', () => this.handleResize());
	}

	private init() {
		this.instance = new Swiper(this.element, {
			cssMode: false,
			preloadImages: true,
			lazy: true,
			speed: 500,
			slidesPerView: 'auto',
			centeredSlides: true,
			roundLengths: true,
			watchOverflow: true,
			loop: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			slideToClickedSlide: true,
			keyboard: true,
			navigation: {
				nextEl: '.js-vehicle-slider-button-next',
				prevEl: '.js-vehicle-slider-button-prev'
			},
			preventClicks: true,
			parallax: true,
			init: true,
			observer: true,
			breakpoints: {
				738: {
					speed: 500
				},
				1195: {
					speed: 1000
				}
			}
		});
		this.handleAfterInit();
		this.instance.on('transitionEnd', () => this.handleTransitionEnd());
	}

	private handleAfterInit() {
		if (this.instance && this.instance.slides) {
			this.instance.slides.forEach(o => {
				new VehicleSliderSlideLoadContent(o);
			});
			this.handleTransitionEnd();
		}
	}

	private handleTransitionEnd() {
		const activeSlide = this.instance.slides[this.instance.activeIndex];
		this.setDetailButtonUrl(activeSlide);
		const vehicleSliderSlideLoadContent =
			VehicleSliderSlideLoadContent.getInstance(activeSlide);
		vehicleSliderSlideLoadContent.handleLoadVehicleSliderSlideContent();
	}

	private initSliderFilterable() {
		this.sliderWrapper = this.element.getElementsByClassName(
			'js-vehicle-slider-wrapper'
		)[0] as HTMLElement;
		var mixitupContainer = getParentWithClass(this.element, 'js-mixitup');
		var allSliderElementsWrapper = this.element.getElementsByClassName(
			'js-vehicle-slider-all-slides'
		)[0] as HTMLElement;
		if (allSliderElementsWrapper && mixitupContainer) {
			mixitupContainer.addEventListener('mixend.merbag.mixitup', () =>
				this.handleSliderSlidesFiltered()
			);
			this.allSliderElements = Array.from(
				allSliderElementsWrapper.getElementsByClassName(
					'js-vehicle-slider-slide'
				)
			) as HTMLElement[];
			this.handleSliderSlidesFiltered();
		}
	}

	private setDetailButtonUrl(activeSlide: HTMLElement) {
		const elementInner = activeSlide.querySelector(
			'.js-vehicle-slider-slide-inner'
		);
		const sliderInfo = this.element.querySelector(
			'.js-vehicle-slider-info'
		);
		if (elementInner && sliderInfo) {
			let linkTo = elementInner.getAttribute('data-modell-url');
			sliderInfo.setAttribute('href', linkTo);
		}
	}

	private handleResize() {
		this.reinitSwiper();
	}

	private reinitSwiper() {
		this.instance.destroy();
		this.init();
	}

	private handleSliderSlidesFiltered() {
		if (this.counterHandleSliderSlidesFiltered) {
			clearTimeout(this.counterHandleSliderSlidesFiltered);
		}
		this.counterHandleSliderSlidesFiltered = setTimeout(() => {
			this.counterHandleSliderSlidesFiltered = 0;
			this.updateSliderSlidesFiltered();
		}, 300);
	}

	private updateSliderSlidesFiltered() {
		removeClass(this.element, 'has--no-filter-results');

		if (this.instance && this.instance !== undefined) {
			this.instance.destroy();
		}
		const slidesToShow = this.allSliderElements.filter(
			o => o.style?.display !== 'none'
		);
		if (slidesToShow.length > 0) {
			let newSlidesHtml = '';
			slidesToShow.forEach(o => {
				newSlidesHtml += o.outerHTML.replace(
					'js-mixitup-item',
					'swiper-slide'
				);
			});
			this.sliderWrapper.innerHTML = newSlidesHtml;
			this.init();
		} else {
			addClass(this.element, 'has--no-filter-results');
		}
	}
}
